<template>
  <div class="g-wrap">
    <div class="page-approve">
      <div class="content">
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
}
</script>

<style lang="scss" scoped>
.g-wrap {
  display: flex;
  width: 100%;
  .page-approve {
    position: relative;
    flex: 1;
    overflow: hidden;
  }
}
</style>


